import React, { useEffect } from 'react'
import { useSelector, shallowEqual } from 'dva'
import workWechatConfig from 'utils/work-wechat-config'
import qs from 'query-string'
import { loginRedirectUrl } from 'utils'
import { ErrorBoundary } from 'components'
import * as ww from '@wecom/jssdk'
import './index.less'

const selector = ({ session }) => ({
  userInfo: session.userInfo,
})
// 企业微信登录
function WorkWeChatQRComponent() {
  const { userInfo } = useSelector(selector, shallowEqual)

  useEffect(() => {
    let search =
      window.sessionStorage.getItem('search') || `?url=${loginRedirectUrl()}`

    let searchObj = qs.parse(search)
    !searchObj?.applicationCode &&
      (search += `&applicationCode=${searchObj?.applicationCode || 'passport'}`)

    const state = searchObj?.nostate
      ? 1
      : JSON.stringify({ type: 'redirect', workId: userInfo?.workId })

    const wwLogin = ww.createWWLoginPanel({
      el: '#wechat-qrcode',
      params: {
        login_type: 'CorpApp',
        appid: workWechatConfig.appid,
        agentid: workWechatConfig.agentid,
        panel_size: 'small',
        // redirect_type: 'callback',
        redirect_uri: workWechatConfig.redirect_uri + search,
        state: encodeURIComponent(encodeURIComponent(state)),
      },
      onCheckWeComLogin({ isWeComLogin }) {
        console.log('isWeComLogin', isWeComLogin)
      },
      onLoginSuccess() {},
      onLoginFail(err) {
        console.log('err', err)
      },
    })

    return () => {
      wwLogin && wwLogin?.unmount()
    }
  }, [userInfo])

  return <div id="wechat-qrcode"></div>
}

export default function WorkWeChatQR() {
  return (
    <ErrorBoundary message="当前不支持企微登录，请切换其他登录方式">
      <WorkWeChatQRComponent />
    </ErrorBoundary>
  )
}
